import { render } from "./accountSidebar.vue?vue&type=template&id=4d9897c0"
import script from "./accountSidebar.vue?vue&type=script&lang=js"
export * from "./accountSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__